import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import PolicyRow from './PolicyRow';
import EditorLabel from '../Editor/EditorLabel';
import EditorContainer from '../Editor/EditorContainer';
import EditorButton from '../Editor/EditorButton';

function PolicySection(props) {
  const {
    sectionType,
    temporaryPolicy,
    isEditing,
    customAttributes,
    agents,
    skills,
    intents,
    channels,
    noMargin,
    validateObject,
  } = props;

  const addNewRow = () => {
    const newObject = { ...temporaryPolicy };

    // add a new empty item to the temporaryPolicy based on the sectionType
    const newRow = sectionType === 'conditions' ? { value: '', type: 'EQUAL', property: '' } : { type: 'SEND_MESSAGE', payload: { message: '' } };
    const newItems = temporaryPolicy[sectionType].concat(newRow);

    newObject[sectionType] = newItems;
    validateObject(newObject);
  };

  const rows = (temporaryPolicy && temporaryPolicy[sectionType]) || [];

  const hasTransferToAgent = temporaryPolicy.actions && temporaryPolicy.actions.reduce(
    (acc, item) => acc || item.type === 'TRANSFER_TO_AGENT', false,
  );

  return (
    <Box
      mt={2}
      p={2}
      pb={0}
      ml={noMargin ? 0 : 1}
      data-testid={`editor-section-${sectionType}`}
    >
      <EditorLabel largeSized={isEditing}>{sectionType}</EditorLabel>
      {rows.length > 0 && (
        <EditorContainer variant="inner">
          {rows.map(
            (item, index) => (
              <PolicyRow
                key={index}
                rowIndex={index}
                rowItem={item}
                isEditing={isEditing}
                temporaryPolicy={temporaryPolicy}
                sectionType={sectionType}
                customAttributes={customAttributes}
                agents={agents}
                skills={skills}
                intents={intents}
                channels={channels}
                isLast={index + 1 === temporaryPolicy[sectionType].length}
                validateObject={validateObject}
                hasTransferToAgent={hasTransferToAgent}
              />
            ),
          )}
        </EditorContainer>
      )}
      <Flex>
        {isEditing && <EditorButton onClick={addNewRow} testid={`add-${sectionType}-row`}>{`Add ${sectionType}`.slice(0, -1)}</EditorButton>}
      </Flex>
    </Box>
  );
}

PolicySection.defaultProps = {
  temporaryPolicy: undefined,
  customAttributes: [],
  skills: [],
  agents: [],
  intents: [],
  channels: [],
  noMargin: false,
};

PolicySection.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  temporaryPolicy: PropTypes.object,
  sectionType: PropTypes.string.isRequired,
  customAttributes: PropTypes.array,
  skills: PropTypes.array,
  agents: PropTypes.array,
  intents: PropTypes.array,
  channels: PropTypes.array,
  noMargin: PropTypes.bool,
  validateObject: PropTypes.func.isRequired,
};

export default PolicySection;
